import React from 'react'
import Aside from '../../shared/Aside'
import MainEarphones from './main/MainEarphones'
import HeaderEarphones from './header/HeaderEarphones'
function Earphones() {
  return (
    <>
      <HeaderEarphones />
      <MainEarphones />
      <Aside />
    </>
  )
}

export default Earphones